import PlateExperimentVariables from './PlateExperimentVariables';
import DilutionTable from './DilutionTable';

import { useContext } from 'react';
import { PlateSelectionContext } from './PlateSelectionProvider'; 
import PlateSelectionItemMenu from './PlateSelectionItemMenu';

export default function PlateEditorMenu({
  mode,
  experiment,
  experimentId,
  globalSet,
  dilutionTable,
  setDilutionTable,
  ops,
}){

  const selected = useContext(PlateSelectionContext);


  



  return (

    <div style={{ minWidth:200 }} class="fair-padding">
      {selected?.wells && (
        <PlateSelectionItemMenu/>
      )}
      {!mode && !selected?.wells && (
        <div>
          <PlateExperimentVariables {...{
            experiment,
            experimentId,
            globalSet
          }}/>
        </div>
      )}
      {mode === "insert" && (<DilutionTable {...{state:dilutionTable,set:setDilutionTable,ops}} />)}
    </div>
  )
}
